module.exports = __webpack_public_path__ + "static/icons/icon-x-e9a515f81a7b3d5bedf1f3b4e4235b16.svg";